import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { CircularProgress } from '@material-ui/core';
import './materialButton.scss';

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            marginRight: theme.spacing(1),
        },
    },
}));

export default function MaterialButton(props) {
    const classes = useStyles();
    const { buttons, style, loading } = props;
    return (
        <div className={classes.root}>
            {
                buttons.map((obj, index) => {
                    let disableClass = "";
                    if (obj.classes.includes('settings-submit-btn')) {
                        disableClass = "settings-submit-btn-disable";
                    }
                    else {
                        disableClass = "disabled";
                    }
                    return (<Button key={index} variant="contained" style={style} className={obj.disabled ? `btn ${disableClass}` : obj.classes} onClick={obj.onClick} disabled={obj.disabled ? true : false}>
                        {obj.loading && obj.loading === true && <CircularProgress size={16} color={obj.loaderColor} className="mb-btn-loader" />}
                        {obj.text}
                    </Button>);
                })
            }
        </div >
    );
}